import { Paper as MuiPaper, PaperProps } from '@mui/material';
import { forwardRef } from 'react';

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ ...rest }, ref) => (
  <MuiPaper ref={ref} {...rest} />
));
